var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view approval-list-grid" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _vm.documentConfigIdProp === 0
              ? _c("cargo-ag-grid", {
                  attrs: {
                    "config-module":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? "33000101"
                        : "44000101",
                    "per-config-name": _vm.perConfigName,
                    "refresh-id": _vm.gridRefreshId,
                    "grid-params": _vm.initiateGrid.gridParams,
                    "grid-options": _vm.initiateGrid.gridOptions,
                    "column-defs":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? [].concat(_vm.initiateGrid.columnDefs)
                        : _vm.initiateGrid.columnDefs.concat([
                            _vm.attachColumn
                          ]),
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(_vm.initiateGrid, "gridParams", $event)
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(_vm.initiateGrid, "gridParams", $event)
                    }
                  }
                })
              : _vm._e(),
            _vm.documentConfigIdProp === _vm.BILL_PAYMENT
              ? _c("cargo-ag-grid", {
                  attrs: {
                    "config-module":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? "33000202"
                        : "44000202",
                    "per-config-name": _vm.perConfigName,
                    "refresh-id": _vm.gridRefreshId,
                    "grid-params": _vm.billPaymentGrid.gridParams,
                    "grid-options": _vm.billPaymentGrid.gridOptions,
                    "column-defs":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? [].concat(_vm.billPaymentGrid.columnDefs)
                        : _vm.billPaymentGrid.columnDefs.concat([
                            _vm.attachColumn
                          ]),
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(_vm.billPaymentGrid, "gridParams", $event)
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(_vm.billPaymentGrid, "gridParams", $event)
                    }
                  }
                })
              : _vm._e(),
            _vm.documentConfigIdProp === _vm.MAKE_INVOICE
              ? _c("cargo-ag-grid", {
                  attrs: {
                    "config-module":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? "33000303"
                        : "44000303",
                    "per-config-name": _vm.perConfigName,
                    "refresh-id": _vm.gridRefreshId,
                    "grid-params": _vm.makeInvoiceGrid.gridParams,
                    "grid-options": _vm.makeInvoiceGrid.gridOptions,
                    "column-defs":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? [].concat(_vm.makeInvoiceGrid.columnDefs)
                        : _vm.makeInvoiceGrid.columnDefs.concat([
                            _vm.attachColumn
                          ]),
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(_vm.makeInvoiceGrid, "gridParams", $event)
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(_vm.makeInvoiceGrid, "gridParams", $event)
                    }
                  }
                })
              : _vm._e(),
            _vm.documentConfigIdProp === _vm.Job_CHARGE
              ? _c("cargo-ag-grid", {
                  attrs: {
                    "config-module":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? "33000404"
                        : "44000404",
                    "per-config-name": _vm.perConfigName,
                    "refresh-id": _vm.gridRefreshId,
                    "grid-params": _vm.jobChargeGrid.gridParams,
                    "grid-options": _vm.jobChargeGrid.gridOptions,
                    "column-defs":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? [].concat(_vm.jobChargeGrid.columnDefs)
                        : _vm.jobChargeGrid.columnDefs.concat([
                            _vm.attachColumn
                          ]),
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(_vm.jobChargeGrid, "gridParams", $event)
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(_vm.jobChargeGrid, "gridParams", $event)
                    }
                  }
                })
              : _vm._e(),
            _vm.documentConfigIdProp === _vm.CHARGE_CHANGE
              ? _c("cargo-ag-grid", {
                  attrs: {
                    "config-module":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? "33000606"
                        : "44000606",
                    "per-config-name": _vm.perConfigName,
                    "refresh-id": _vm.gridRefreshId,
                    "grid-params": _vm.chargeChangeGrid.gridParams,
                    "grid-options": _vm.chargeChangeGrid.gridOptions,
                    "column-defs":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? [].concat(_vm.chargeChangeGrid.columnDefs)
                        : _vm.chargeChangeGrid.columnDefs.concat([
                            _vm.attachColumn
                          ]),
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(
                        _vm.chargeChangeGrid,
                        "gridParams",
                        $event
                      )
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(
                        _vm.chargeChangeGrid,
                        "gridParams",
                        $event
                      )
                    }
                  }
                })
              : _vm._e(),
            _vm.documentConfigIdProp === _vm.TEMP_CREDIT
              ? _c("cargo-ag-grid", {
                  attrs: {
                    "config-module":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? "33000505"
                        : "44000505",
                    "per-config-name": _vm.perConfigName,
                    "refresh-id": _vm.gridRefreshId,
                    "grid-params": _vm.tempCreditGrid.gridParams,
                    "grid-options": _vm.tempCreditGrid.gridOptions,
                    "column-defs":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? [].concat(_vm.tempCreditGrid.columnDefs)
                        : _vm.tempCreditGrid.columnDefs.concat([
                            _vm.attachColumn
                          ]),
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(_vm.tempCreditGrid, "gridParams", $event)
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(_vm.tempCreditGrid, "gridParams", $event)
                    }
                  }
                })
              : _vm._e(),
            _vm.documentConfigIdProp === _vm.COLLECT_INVOICE
              ? _c("cargo-ag-grid", {
                  attrs: {
                    "config-module":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? "33000707"
                        : "44000707",
                    "per-config-name": _vm.perConfigName,
                    "refresh-id": _vm.gridRefreshId,
                    "grid-params": _vm.collectInvoiceGrid.gridParams,
                    "grid-options": _vm.collectInvoiceGrid.gridOptions,
                    "column-defs":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? [].concat(_vm.collectInvoiceGrid.columnDefs)
                        : _vm.collectInvoiceGrid.columnDefs.concat([
                            _vm.attachColumn
                          ]),
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(
                        _vm.collectInvoiceGrid,
                        "gridParams",
                        $event
                      )
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(
                        _vm.collectInvoiceGrid,
                        "gridParams",
                        $event
                      )
                    }
                  }
                })
              : _vm._e(),
            _vm.documentConfigIdProp === _vm.PARTNER_APPLICATION_FORM
              ? _c("cargo-ag-grid", {
                  attrs: {
                    "config-module":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? "33000808"
                        : "44000808",
                    "per-config-name": _vm.perConfigName,
                    "refresh-id": _vm.gridRefreshId,
                    "grid-params": _vm.companyGrid.gridParams,
                    "grid-options": _vm.companyGrid.gridOptions,
                    "column-defs":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? [].concat(_vm.companyGrid.columnDefs)
                        : _vm.companyGrid.columnDefs.concat([_vm.attachColumn]),
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(_vm.companyGrid, "gridParams", $event)
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(_vm.companyGrid, "gridParams", $event)
                    }
                  }
                })
              : _vm._e(),
            _vm.documentConfigIdProp === _vm.CONTRACT_APPLICATION_FORM
              ? _c("cargo-ag-grid", {
                  attrs: {
                    "config-module":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? "33000909"
                        : "44000909",
                    "per-config-name": _vm.perConfigName,
                    "refresh-id": _vm.gridRefreshId,
                    "grid-params": _vm.contractGrid.gridParams,
                    "grid-options": _vm.contractGrid.gridOptions,
                    "column-defs":
                      _vm.type === _vm.WORKFLOW_TYPE_LOOK
                        ? [].concat(_vm.contractGrid.columnDefs)
                        : _vm.contractGrid.columnDefs.concat([
                            _vm.attachColumn
                          ]),
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(_vm.contractGrid, "gridParams", $event)
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(_vm.contractGrid, "gridParams", $event)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "div",
        {},
        [
          _vm.documentConfigIdProp === 0
            ? _c("cargo-pagination", {
                attrs: {
                  "config-module":
                    _vm.type === _vm.WORKFLOW_TYPE_LOOK
                      ? "33000101"
                      : "44000101",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            : _vm._e(),
          _vm.documentConfigIdProp === _vm.BILL_PAYMENT
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    width: "100%",
                    "flex-direction": "row",
                    "justify-content": "space-between"
                  }
                },
                [
                  _c(
                    "div",
                    [
                      _vm.documentConfigIdProp === _vm.BILL_PAYMENT
                        ? _c("cargo-pagination", {
                            attrs: {
                              "config-module":
                                _vm.type === _vm.WORKFLOW_TYPE_LOOK
                                  ? "33000202"
                                  : "44000202",
                              total: _vm.total,
                              page: _vm.filter.pageNum,
                              limit: _vm.filter.pageSize
                            },
                            on: {
                              "update:page": function($event) {
                                return _vm.$set(_vm.filter, "pageNum", $event)
                              },
                              "update:limit": function($event) {
                                return _vm.$set(_vm.filter, "pageSize", $event)
                              },
                              pagination: _vm.toQuery
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" }
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.totalAmountToCurrencyBillPaymentGrid
                              .selectionCountLabel
                          )
                        }
                      }),
                      _vm.reCalc &&
                      _vm.documentConfigIdProp === _vm.BILL_PAYMENT
                        ? _c("charge-currency-total-group", {
                            attrs: {
                              type: "both",
                              "amount-to-currency": _vm.localCurrency,
                              "data-field": "amount",
                              "data-provider":
                                _vm.totalAmountToCurrencyBillPaymentGrid
                                  .dataProvider,
                              "rate-field": "converRate",
                              "ar-field": "ar",
                              "show-wht": true
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.documentConfigIdProp === _vm.MAKE_INVOICE
            ? _c("cargo-pagination", {
                attrs: {
                  "config-module":
                    _vm.type === _vm.WORKFLOW_TYPE_LOOK
                      ? "33000303"
                      : "44000303",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            : _vm._e(),
          _vm.documentConfigIdProp === _vm.Job_CHARGE
            ? _c("cargo-pagination", {
                attrs: {
                  "config-module":
                    _vm.type === _vm.WORKFLOW_TYPE_LOOK
                      ? "33000404"
                      : "44000404",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            : _vm._e(),
          _vm.documentConfigIdProp === _vm.CHARGE_CHANGE
            ? _c("cargo-pagination", {
                attrs: {
                  "config-module":
                    _vm.type === _vm.WORKFLOW_TYPE_LOOK
                      ? "33000606"
                      : "44000606",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            : _vm._e(),
          _vm.documentConfigIdProp === _vm.TEMP_CREDIT
            ? _c("cargo-pagination", {
                attrs: {
                  "config-module":
                    _vm.type === _vm.WORKFLOW_TYPE_LOOK
                      ? "33000505"
                      : "44000505",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            : _vm._e(),
          _vm.documentConfigIdProp === _vm.COLLECT_INVOICE
            ? _c("cargo-pagination", {
                attrs: {
                  "config-module":
                    _vm.type === _vm.WORKFLOW_TYPE_LOOK
                      ? "33000707"
                      : "44000707",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            : _vm._e(),
          _vm.documentConfigIdProp === _vm.PARTNER_APPLICATION_FORM
            ? _c("cargo-pagination", {
                attrs: {
                  "config-module":
                    _vm.type === _vm.WORKFLOW_TYPE_LOOK
                      ? "33000808"
                      : "44000808",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            : _vm._e(),
          _vm.documentConfigIdProp === _vm.CONTRACT_APPLICATION_FORM
            ? _c("cargo-pagination", {
                attrs: {
                  "config-module":
                    _vm.type === _vm.WORKFLOW_TYPE_LOOK
                      ? "33000909"
                      : "44000909",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.jobApplyDialog.visible
        ? _c("job-apply-dialog", {
            attrs: {
              visible: _vm.jobApplyDialog.visible,
              title: _vm.applyDialogTitle,
              "process-info": _vm.selectRow,
              records: _vm.approvalCommentsRecords,
              type: _vm.type,
              "doc-id": _vm.docId,
              "document-config-id": _vm.documentConfigId
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.jobApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.jobApplyDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.jobApplyDialog.visible = false
                _vm.applyCloseAndRefresh()
              }
            }
          })
        : _vm._e(),
      _vm.invoiceDetailDialog.visible
        ? _c("invoice-detail-dialog", {
            ref: "makeInvoiceDialog",
            attrs: {
              "is-bpm": true,
              "process-info": _vm.selectRow,
              records: _vm.approvalCommentsRecords,
              type: _vm.type,
              visible: _vm.invoiceDetailDialog.visible,
              title: _vm.$t("Invoice.invoice_invoiceInformation"),
              properties: _vm.invoiceProperties,
              "last-process-node": _vm.lastProcessNode,
              "view-source": "tabInvoiceQuery"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.invoiceDetailDialog, "visible", $event)
              },
              pageChange: _vm.pageChange,
              close: function($event) {
                _vm.invoiceDetailDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.invoiceDetailDialog.visible = false
                _vm.applyCloseAndRefresh()
              }
            }
          })
        : _vm._e(),
      _vm.billDialog.visible
        ? _c("bill-dialog", {
            ref: "billDialog",
            attrs: {
              "is-bpm": true,
              "process-info": _vm.selectRow,
              records: _vm.approvalCommentsRecords,
              type: _vm.type,
              visible: _vm.billDialog.visible,
              "billing-uuid": _vm.docId,
              "is-view": true,
              "last-process-node": _vm.lastProcessNode
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.billDialog, "visible", $event)
              },
              close: function($event) {
                _vm.billDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.billDialog.visible = false
                _vm.applyCloseAndRefresh()
              }
            }
          })
        : _vm._e(),
      _vm.chargeWorkFlowApplyDialog.visible
        ? _c("charge-apply-dialog", {
            ref: "workFlowApplyDialog",
            attrs: {
              visible: _vm.chargeWorkFlowApplyDialog.visible,
              "change-charge": _vm.chargeWorkFlowApplyDialog.changeCharge,
              title: _vm.applyDialogTitle,
              "process-info": _vm.selectRow,
              records: _vm.records,
              type: _vm.type
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.chargeWorkFlowApplyDialog,
                  "visible",
                  $event
                )
              },
              close: function($event) {
                _vm.chargeWorkFlowApplyDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.chargeWorkFlowApplyDialog.visible = false
                _vm.applyCloseAndRefresh()
              }
            }
          })
        : _vm._e(),
      _vm.companyDialog.visible
        ? _c("company-apply-dialog", {
            ref: "companyApplyDialog",
            attrs: {
              visible: _vm.companyDialog.visible,
              "company-bpm": _vm.companyDialog.companyBpm,
              title: _vm.applyDialogTitle,
              "process-info": _vm.selectRow,
              records: _vm.approvalCommentsRecords,
              type: _vm.type
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.companyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.companyDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.companyDialog.visible = false
                _vm.applyCloseAndRefresh()
              }
            }
          })
        : _vm._e(),
      _vm.contractDialog.visible
        ? _c("contract-apply-dialog", {
            ref: "contractApplyDialog",
            attrs: {
              visible: _vm.contractDialog.visible,
              "contract-bpm": _vm.contractDialog.contractBpm,
              title: _vm.applyDialogTitle,
              "process-info": _vm.selectRow,
              records: _vm.approvalCommentsRecords,
              type: _vm.type
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.contractDialog, "visible", $event)
              },
              close: function($event) {
                _vm.contractDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.contractDialog.visible = false
                _vm.applyCloseAndRefresh()
              }
            }
          })
        : _vm._e(),
      _vm.tempCreditApplyDialog.visible
        ? _c("temp-credit-apply-dialog", {
            ref: "tempCreditApplyDialog",
            attrs: {
              "is-bpm": true,
              "process-info": _vm.selectRow,
              records: _vm.approvalCommentsRecords,
              type: _vm.type,
              visible: _vm.tempCreditApplyDialog.visible,
              "doc-id": _vm.docId
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.tempCreditApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.tempCreditApplyDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.tempCreditApplyDialog.visible = false
                _vm.applyCloseAndRefresh()
              }
            }
          })
        : _vm._e(),
      _vm.processRecordsDialog.visible
        ? _c("process-records", {
            attrs: {
              visible: _vm.processRecordsDialog.visible,
              "process-detail": _vm.processDetail,
              records: _vm.records,
              "workflow-name": _vm.workflowName,
              "document-config-name": _vm.documentConfigName
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.processRecordsDialog, "visible", $event)
              },
              close: function($event) {
                _vm.processRecordsDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _c("file-manage-dialog", {
        attrs: {
          visible: _vm.fileManageDialog.visible,
          files: _vm.fileManageDialog.files
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fileManageDialog, "visible", $event)
          }
        }
      }),
      _c("pre-view-file-dialog", {
        attrs: {
          title: _vm.$t("FileHistory.preview"),
          visible: _vm.previewFileData.visible,
          file: _vm.previewFileData.file,
          "can-maximize": true
        },
        on: { close: _vm.closePreviewDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }